module.exports = __webpack_public_path__ + "static/media/26_negro.a60a3913.svg";